module.exports = __webpack_public_path__ + "static/media/ends_with_i.3a5b1330.mp3";